/**
 * Changes the body attribute
 */
const changeBodyAttribute = (attribute: string, value: string): void => {
    if (document.body) document.body.setAttribute(attribute, value);
};

/**
 * Changes the body attribute
 */
const changeBodyAttributeLeftbarMode = ( value: boolean): void => {
    if (document.body){
        if (value) {
            document.body.setAttribute("data-leftbar-compact-mode", "fixed");
        } else {
            document.body.setAttribute("data-leftbar-compact-mode", "condensed");
        }
    }
};

const changeSideMenuMobileMode = ( value: boolean): void => {
    
    if (value) {
        // document.body.classList.remove("sidebar-enable");
        document.body.classList.add("sidebar-enable");
    } else {
        // document.body.classList.add("sidebar-enable");
        document.body.classList.remove("sidebar-enable");
    }
};

export { changeBodyAttribute, changeBodyAttributeLeftbarMode, changeSideMenuMobileMode };
